import type React from 'react';

import type { Tournament } from '../../types/MTT';
import Tooltip from '../Tooltip/Tooltip';

import styles from './shared.scss';
import { getSeatsIcon } from './utils';

interface Props {
  seats: Tournament['seats'];
}

const SeatsStatusIcon: React.FC<Props> = ({ seats }) => {
  const { Icon, TooltipContent } = getSeatsIcon(seats);

  return (
    <Tooltip
      content={TooltipContent}
      placement="bottom"
      arrowClassName={styles.tooltipArrow}
      tooltipClassName={styles.tooltip}
      refElementClassName={styles.tooltipWrapper}
    >
      {Icon}
    </Tooltip>
  );
};

export default SeatsStatusIcon;
